import { useDisclosure } from '@mantine/hooks';
import { Modal, Group, Button, Text, Stack, Alert } from '@mantine/core';
import { IconCircleCheck, IconExclamationCircle, IconAlertCircle } from '@tabler/icons-react';

export const InfoModal = ({ title, handleCloseModal, children }) => {
  const [opened, { open, close }] = useDisclosure(true);

  const handleOnClose = () => {
    close();
    handleCloseModal();
  }

  return (
    <>
      <Modal opened={opened} onClose={handleOnClose} title={title}>
        { children }
      </Modal>
    </>
  );
}

export const SuccessModal = ({title, description, handleCloseModal}) => {
  return (
    <InfoModal
      title={title}
      handleCloseModal={handleCloseModal}
    >
      <Alert icon={<IconCircleCheck size="2rem" />} title={title} color="green">
        <Text fz="lg">{description}</Text>
      </Alert>
    </InfoModal>
  )
}

export const ErrorModal = ({title, description, handleCloseModal}) => {
  return (
    <InfoModal
      title={title}
      handleCloseModal={handleCloseModal}
    >
      <Alert icon={<IconAlertCircle size="2rem" />} title={title} color="red">
        <Text fz="lg">{description}</Text>
      </Alert>
    </InfoModal>
  )
}